/* src/app/components/controls/sem-html-js/sem-html-js.component.css */
.input-wrapper {
  height: 100%;
  overflow: hidden;
}
.html-js-content {
  height: calc(100% - 99px);
  position: relative;
  font-family: "roboto";
  color: #313541;
  padding: 5px 30px;
}
/*# sourceMappingURL=sem-html-js.component.css.map */
